import { useNavigate } from "react-router-dom";
import { FiEye } from "react-icons/fi";

export default function RelatedVideoCard({ video }) {
  const navigate = useNavigate();

  const views =
    video?.totalViews ??
    video?.views ??
    video?.viewsCount ??
    0;

  return (
    <div
      onClick={() => navigate(`/video/${video._id}`)}
      style={{
        display: "flex",
        gap: 12,
        cursor: "pointer",
        marginBottom: 14,
      }}
    >
      {/* Thumbnail */}
      <img
        src={video.videoImage}
        alt={video.title}
        style={{
          width: 120,
          height: 70,
          objectFit: "cover",
          borderRadius: 6,
          background: "#000",
        }}
      />

      {/* Meta */}
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            lineHeight: "1.3",
            marginBottom: 4,
          }}
        >
          {video.title}
        </div>

        <div style={{ fontSize: 12, color: "#666" }}>
          {video.user?.fullName || "Unknown Channel"}
        </div>

        <div
          style={{
            fontSize: 12,
            color: "#666",
            marginTop: 2,
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <FiEye size={13} />
          {views.toLocaleString()} views
        </div>
      </div>
    </div>
  );
}
